import { render, staticRenderFns } from "./StorageWindow.vue?vue&type=template&id=a0761004&"
import script from "./StorageWindow.vue?vue&type=script&lang=js&"
export * from "./StorageWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports